import { Component } from '@angular/core';
import { ApiService } from '../../../services/api.service';

@Component({
  selector: 'ngx-footer',
  styleUrls: ['./footer.component.scss'],
  template: `

    <div [dir]='apiService.currentDirection'
    [ngStyle]="{'font-family' :this.apiService.currentDirection == 'ltr'? 'sans-serif': 'vazir'}">
    <a style="cursor: pointer;" href="https://medis.land/">
        <img src="../../../assets/images/Medis.png"
            style="width: 30px;height: auto; padding-bottom: 5px; cursor: pointer;" />
    </a>
    {{ 'PoweredByMedis' | translate }} &copy; {{ date  }}

    </div>

  `,
})
export class FooterComponent {
  date = new Date().getFullYear()
  constructor(
    public apiService: ApiService,) { }
}
// <span class="created-by">
// Created with ♥ by <b><a href="https://akveo.page.link/8V2f" target="_blank">Akveo</a></b> 2019
// </span>
// <div class="socials">
// <a href="#" target="_blank" class="ion ion-social-github"></a>
// <a href="#" target="_blank" class="ion ion-social-facebook"></a>
// <a href="#" target="_blank" class="ion ion-social-twitter"></a>
// <a href="#" target="_blank" class="ion ion-social-linkedin"></a>
// </div>